export default Object.freeze({
  CONFIGURATION: '사은품 기본설정',
  GIVING_CONDITION: '사은품 지급조건 관리',
  SHOPPING_MALL: '쇼핑몰',
  USABLE: '사은품 사용여부',
  DUPLICATED_AVAILABLE: '사은품 중복지급 허용',
  HELP_DUPLICATED_AVAILABLE: '사은품 중복지급 허용 설정 안내',
  CONFORM_CHANGE_CONFIGURATION: '설정을 변경하시겠습니까? \n' +
    '단, 변경 이후 생성된 주문부터 변경된 설정이 적용됩니다.',
  CONFIGURATION_NOTICE_1: '사은품 사용여부에 따라 주문 시 사은품 지급여부를 설정할 수 있습니다.',
  CONFIGURATION_NOTICE_2: '사은품 사용여부를 \'사용 안 함\'으로 설정하더라도 사은품 관련 설정은 가능하며, 지급만 제한됩니다.',
  CONFIGURATION_NOTICE_3: '사은품 사용여부를 변경한 경우, 변경한 시점 이후 생성된 주문부터 번경된 설정이 적용됩니다.',
  CONFIGURATION_NOTICE_4: '즉, 사용여부를 \'사용 안 함\'으로 변경하더라도, 변경 이전에 생성된 주문의 경우 사은품이 지급될 수 있습니다.',
  CONFIGURATION_HELP_1: '1개 상품에 복수 개의 사은품 지급조건 적용이 가능합니다.',
  CONFIGURATION_HELP_2: '사은품 중복지급 허용 설정을 통해 1개의 상품에 1개의 지급조건만 지급 가능하도록 제한할 수 있습니다.',
  CONFIGURATION_HELP_3: '사은품 중복지급 허용 설정을 ‘허용 안 함’으로 설정할 경우, 여러 지급조건을 충족하더라도 지급조건의 \n 등록일 기준으로 가장 최근에 등록된 1개의 지급조건만 적용됩니다.',
  CONFIGURATION_HELP_4: '사은품 중복지급 허용 설정을 ‘허용 안 함’으로 설정하더라도 대상상품 중복 설정이 제한되지는 않으며, \n  실제 지급 시 지급 가능한 지급조건 중 1개만 적용합니다.',
  CONDITION_NAME: '지급조건명',
  CONDITION_NO: '지급조건번호',
  REGISTER_NAME: '등록자',
  UPDATER_NAME: '수정자',
  REGISTER_AT: '등록일',
  START_AT: '시작일',
  END_AT: '종료일',
  READY: '지급대기',
  ON: '지급중',
  STOP: '지급중지',
  FINISH: '지급종료',
  GIVE_STATUS_TYPE_TITLE: '지급상태',
  
  ALERT_GIVE_STATUS_TYPE: '지급상태값은 1개 이상 선택해야 합니다.',
  REGISTER_GIVE_CONDITION: '지급조건 등록',
  
  GRID_TITLE_GIVE_CONDITION_NO: '지급번호',
  GRID_TITLE_MALL_NAME: '쇼핑몰',
  GRID_TITLE_PARTNER_NAME: '파트너사',
  GRID_TITLE_GIVE_CONDITION_NAME: '지급조건명',
  GRID_TITLE_GIVE_STATUS_TYPE: '지급상태',
  GRID_TITLE_GIVE_PERIOD: '지급기간',
  GRID_TITLE_REGISTER_NAME: '지급등록자',
  GRID_TITLE_REGISTER_DATE_TIME: '등록일시',
  GRID_TITLE_UPDATER_NAME: '최종수정자',
  GRID_TITLE_UPDATER_DATE_TIME: '최종수정일',
  
  GRID_TITLE_PRODUCT_NO: '상품번호',
  GRID_TITLE_PRODUCT_NAME: '상품명',
  GRID_TITLE_SALE_METHOD_TYPE: '판매방식',
  GRID_TITLE_COMMISSION_RATE: '수수료율',
  GRID_TITLE_SUPPLY_PRICE: '공급가',
  GRID_TITLE_PURCHASE_PRICE: '매입가',
  GRID_TITLE_PRICE: '판매가/할인적용가',
  GRID_TITLE_ADD_DATE_TIME: '추가일',
  
  GRID_TITLE_OPTION_NO: '옵션번호',
  GRID_TITLE_OPTION_LABEL: '옵션명·옵션값',
  GRID_TITLE_GIVE_AVAILABILITY: '지급가능여부',
  GRID_TITLE_STOCK: '재고',
  GRID_TITLE_SALE_STATUS: '판매상태',
  GRID_TITLE_PROMOTION_AVAILABILITY: '프로모션 가능여부',
  GRID_TITLE_PRICE_AND_DISCOUNT_PRICE: '판매가/할인적용가',
  GRID_TITLE_OPTION_PRICE: '옵션판매가',
  GRID_TITLE_APPLY_STATUS_TYPE: '승인상태',
  GRID_TITLE_SALE_STATUS_TYPE: '판매설정',
  
  CONDITION_REGISTRATION_NOTICE_1: '사은품은 ',
  CONDITION_REGISTRATION_NOTICE_2: '결제완료 시점에 주문상품으로 추가',
  CONDITION_REGISTRATION_NOTICE_3: '되며, 입금대기 시에는 ',
  CONDITION_REGISTRATION_NOTICE_4: '[주문상세 > 혜택지급내역 > 사은품혜택 상세 팝업]',
  CONDITION_REGISTRATION_NOTICE_5: '을 통해 지급대기중인 사은품 확인이 가능합니다.',
  CONDITION_REGISTRATION_NOTICE_6: '사은품은 설정한 대상상품별로 지급조건을 체그하여 지급됩니다.',
  CONDITION_REGISTRATION_NOTICE_7: '즉, 주문 내 동일 지급조건의 대상상품이 복수 개 포함되어 있는 경우, 각 상품별로 지급조건을 체크하여 사은품을 지급합니다.',
  CONDITION_REGISTRATION_NOTICE_8: '1개 대상상품에 사은품 지급조건이 중복으로 설정된 경우 1개 상품에 복수 개 지급조건이 적용될 수 있습니다.',
  CONDITION_REGISTRATION_NOTICE_9: '사은품 기본설정 메뉴에서 중복지급 허용 설정을 통해 1개의 상품에 1개의 지급조건만 지급 가능하도록 제한할 수 있습니다. (대상상품 중복 설정은 가능)',
  
  CONFIRM_CHANGE_MALL: '쇼핑몰 수정할 경우 일부 설정값이 초기화됩니다. \n수정하시겠습니까?',
  
  CONDITION_TITLE: '사은품 지급조건 {mode}',
  CONDITION_SUB_TITLE_BASIC_INFORMATION: '사은품 기본정보',
  GIVE_CONDITION_NAME: '지급조건명',
  GIVE_CONDITION_EXPLAIN: '지급조건 설명',
  
  PLACEHOLDER_GIVE_CONDITION_NAME: '지급조건명 입력',
  PLACEHOLDER_GIVE_CONDITION_EXPLAIN: '지급조건 설명 입력',
  SELECT: '선택',
  
  CONDITION_SUB_TITLE_GIVE_INFORMATION: '사은품 지급정보',
  GIVE_PERIOD: '지급기간',
  GIVE_TARGET_MEMBER: '지급대상 회원',
  MEMBER_GRADE_GROUP: '회원등급/그룹',
  EXCLUDE_GUEST: '비회원 제외',
  PAYMENT_CONDITION: '금액조건',
  PAYMENT_LIMIT: '원 이상 구매 시 사은품 지급',
  
  ALERT_SELECT_MALL: '쇼핑몰을 선택해주세요.',
  PLZ_PRICE: '금액을 입력해주세요.',
  PLZ_CHECK_UNIT: '10원 단위로 입력하실 수 있습니다.',
  
  TOOLTIP_GIVE_1: '상품별로 금액조건을 체크하여 사은품을 지급합니다.',
  TOOLTIP_GIVE_2: '금액기준 : 판매가 – 즉시할인금액 ± 옵션가 – 추가할인금액 – 상품쿠폰 할인금액',

  TOOLTIP_GIVE_OPTION_1: '사은품 지급 옵션을 복수 개로 설정한 경우, 지급조건 충족 시 복수 개 옵션이 모두 지급됩니다.',
  TOOLTIP_GIVE_OPTION_2: '구매자작성형 옵션이 설정된 상품을 사은품으로 불러올 경우, 사은품 지급 시 구매자작성형 옵션은 적용되지 않으니 유의하시기 바랍니다.',
  
  SELECT_MEMBER: '회원선택',
  NO_LIMIT: '제한없음',
  
  CONDITION_SUB_TITLE_TARGET_INFORMATION: '사은품 대상 설정',
  TARGET: '지급 대상',
  EXCLUDE_TARGET_CONFIG: '지급 대상 제외 설정',
  EXCLUDE_TARGET_PRODUCTS: '사은품 대상 제외 상품',
  TARGET_PRODUCTS: '사은품 대상 상품',
  
  ALL: '전상품',
  PRODUCT: '개별상품',
  BRAND: '브랜드',
  DISPLAY: '전시카테고리',
  PARTNER: '파트너사',
  NOT_USE: '설정 안 함',
  USE: '설정',
  
  PURCHASE: '사입',
  CONSIGNMENT: '위탁',
  
  ADD_SELECTED_OPTIONS: '선택옵션 추가',
  DELETE_SELECTED_PRODUCT: '선택상품 삭제',
  SEARCH_PRODUCTS: '상품 조회',
  
  CONDITION_SUB_TITLE_APPORTIONMENT_INFORMATION: '사은품 설정',
  APPORTIONMENT_CONFIG: '분담비율 설정',
  MALL_SHARE_RATE: '쇼핑몰 부담',
  PARTNER_SHARE_RATE: '파트너 부담',
  
  FREE_GIFT_OPTION: '사은품 지급 옵션',
  DELETE_SELECTED_OPTION: '선택옵션 삭제',
  SEARCH_OPTION: '옵션 조회',
  
  PRODUCT_NAME: '상품명',
  MALL_PRODUCT_NO: '상품번호',
  PRODUCT_MANAGEMENT_CD: '상품관리코드',
  MALL_OPTION_NO: '옵션번호',
  OPTION_MANAGEMENT_CD: '옵션관리코드',
  
  SEARCH_PROMOTION_OPTION: '사은품 조회/선택',
  
  OPTION_LIST_TOTAL: '옵션 목록 총 ',
  
  PRE_APPROVAL_STATUS: '승인완료이전',
  ON_PRE_SALE: '예약판매중',
  WAITING_SALE: '판매대기',
  ON_SALE: '판매중',
  END_SALE: '판매종료',
  
  AVAILABLE_FOR_SALE: '판매가능',
  STOP_SELLING: '판매중지',
  PROHIBITION_SALE: '판매금지',
  
  PLACEHOLDER_BRAND: '브랜드명 검색',
  PLACEHOLDER_PARTNER: '파트너사명 검색',
  
  PLZ_SELECT_PRODUCT_TO_REMOVE: '삭제할 상품을 선택해주세요.',
  PLZ_SELECT_OPTION_TO_REMOVE: '삭제할 옵션을 선택해주세요.',
  PLZ_GIVE_CONDITION_NAME: '지급조건명을 입력해주세요.',
  PLZ_UPPER_PRICE: '금액조건을 입력해주세요.',
  PLZ_SELECT_TARGET_NOS: '대상상품을 선택해주세요.',
  PLZ_SELECT_EXCLUDE_TARGET_NOS: '제외 상품을 선택해주세요.',
  PLZ_SELECT_FREE_GIFTS: '사은품을 선택해주세요.',
  PLZ_SELECT_MEMBER: '회원등급/그룹을 설정해주세요.',
  
  ALERT_NO_SELECTED_OPTION: '선택된 옵션이 없습니다.',
  ALERT_MAX_SIZE_OPTIONS: '사은품은 최대 {success}개까지 선택할 수 있습니다.\n초과된 개수만큼 제외하고 추가됩니다',
  ALERT_MAX_SIZE_PRODUCTS: '상품은 최대 {limit}개까지 선택할 수 있습니다.\n초과된 개수만큼 제외하고 추가됩니다',
  ALERT_ADDED: '추가 되었습니다. 성공 {success}건 실패 {failure}건',
  
  STOP_BTN: '지급중지',
  AVAILABLE_BTN: '지급재시작',
  FINISH_BTN: '지급종료',
  
  CONFIRM_STOP_GIVE_STATUS: '지급상태를 지급중지로 변경하시겠습니까?\n변경 시 사은품 지급이 일시적으로 중단됩니다.',
  CONFIRM_RESTART_GIVE_STATUS: '지급상태를 지급중으로 변경하시겠습니까?\n변경 시 사은품 지급이 재개됩니다',
  CONFIRM_FINISH_GIVE_STATUS: '지급상태를 지급종료로 변경하시겠습니까?\n변경 시 해당 지급조건으로 사은품 지급이 불가합니다.',
});
